import ScanCapacityBanner from './ScanCapacityBanner.container';

export default ScanCapacityBanner;
